import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import ToggleIcon from '../ToggleIcon';
import FormatDialog from './Dialog';

var FormatButton = function FormatButton(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      disabled = _ref.disabled;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClick = function handleClick() {
    setOpen(true);
  };

  var getFormatType = function getFormatType() {
    if (value) {
      if (value.startsWith('number:')) return 'number-format';
      if (value.startsWith('currency:')) return 'currency-format';
      if (value.startsWith('date:')) return 'date-format';
    }

    return 'alphabetical';
  };

  return React.createElement("div", null, React.createElement(ToggleIcon, {
    type: getFormatType(),
    onClick: handleClick,
    disabled: disabled,
    label: 'Format',
    checked: value
  }), open && React.createElement(FormatDialog, {
    onClose: function onClose() {
      return setOpen(false);
    },
    value: value,
    onChange: function onChange(format) {
      setOpen(false);

      _onChange(format);
    }
  }));
};

export default FormatButton;